import React, { useEffect } from 'react';
import { useState } from 'react';
import { useHRMS } from '../context/HRMSContext.jsx';
import ApiTest from '../components/ApiTest.jsx';




function Dashboard() {
  const { state, loadLeaves, loadWorkers } = useHRMS();

  useEffect(() => {
    loadLeaves();
    loadWorkers();
  }, []);
 
  const getTodayDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const totalWorkers = Array.isArray(state.workers) ? state.workers.length : 0;


  const presentToday = Array.isArray(state.attendance) ? state.attendance.filter(att => {
    const attDate = att.date ? new Date(att.date).toISOString().split('T')[0] : '';
    return att.status === 0 && attDate === getTodayDate();
  }).length : 0;
  const pendingLeaves = Array.isArray(state.leaves) ? state.leaves.filter(leave => 
    leave.leaveStatus === 0 || leave.leaveStatus === null || leave.leaveStatus === undefined
  ).length : 0;
  const totalDepartments = Array.isArray(state.workers) ? [...new Set(state.workers.map(worker => worker.department))].length : 0;

  const getShiftName = (shiftId) => {
    if (!shiftId || !Array.isArray(state.shifts)) return '';
    const shift = state.shifts.find(shift => shift.id === shiftId);
    return shift ? shift.shiftName : '';
  };


  
  return (
    <div className="dashboard">
      <h2>Dashboard</h2>
      <ApiTest />
      <div className="row">
        <div className="col-md-3">
          <div className="card bg-primary text-white">
            <div className="card-body">
              <h5>Total Workers</h5>
              <h3>{totalWorkers}</h3>
            </div>
          </div>
        </div>
        
        <div className="col-md-3">
          <div className="card bg-success text-white">
            <div className="card-body">
              <h5>Present Today</h5>
              <h3>{presentToday}</h3>
            </div>
          </div>
        </div>
        <div className="col-md-3">
          <div className="card bg-warning text-white">
            <div className="card-body">
              <h5>Pending Leaves</h5>
              <h3>{pendingLeaves}</h3>
            </div>
          </div>
        </div>
        <div className="col-md-3">
          <div className="card bg-info text-white">
            <div className="card-body">
              <h5>Departments</h5>
              <h3>{totalDepartments}</h3>
            </div>
          </div>
        </div>
      </div>

      <div className="row mt-4">
        <div className="col-md-6">
          <div className="card">
            <div className="card-header">
              <h5>Recent Worker</h5>
              

            </div>
            <div className="card-body">
              <div className="table-responsive">
                <table className="table table-sm">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Department</th>
                      <th>Shift</th>
                      <th>Join Date</th>
                    </tr>
                  </thead>
                  <tbody>

                    {Array.isArray(state.workers) ? state.workers.slice(-4).map(worker => (
                      <tr key={worker.id}>
                        <td>{worker.name}</td>
                        <td>{worker.department}</td>
                        <td>{getShiftName(worker.shiftId) || '-'}</td>
                        <td>{worker.joinDate}</td>
                      </tr>
                    )) : <tr><td colSpan="4">No workers found</td></tr>}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        <div className="col-md-6">
          <div className="card">
            <div className="card-header">
              <h5>Pending Leave Requests</h5>
            </div>
            <div className="card-body">
              <div className="table-responsive">
                <table className="table table-sm">
                  <thead>
                    <tr>
                      <th>Worker</th>
                      <th>Type</th>
                      <th>Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    {Array.isArray(state.leaves) && state.leaves.length > 0 ? 
                      state.leaves.filter(leave => 
                        leave.leaveStatus === 0 || leave.leaveStatus === null || leave.leaveStatus === undefined
                      ).map(leave => {
                        const worker = Array.isArray(state.workers) ? state.workers.find(w => w.id === leave.empId) : null;
                        return (
                          <tr key={leave.id}>
                            <td>{worker?.name || `Worker ${leave.empId}`}</td>
                            <td>{leave.type}</td>
                            <td>{leave.startDt}</td>
                          </tr>
                        );
                      }) : 
                      <tr><td colSpan="3" className="text-center">No pending leaves</td></tr>
                    }
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Dashboard;